/**
 * List component overrides.
 * Modern list items with smooth transitions.
 */

import type { Theme } from '@mui/material/styles';

const list: Theme['components'] = {
  MuiListItem: {
    styleOverrides: {
      root: ({ theme }) => ({
        gap: theme.spacing(3),
      }),
      padding: ({ theme, ownerState }) => ({
        ...(!ownerState.dense && {
          paddingBlock: theme.spacing(2),
          paddingInlineStart: theme.spacing(5),
        }),
      }),
    },
  },
  MuiListItemAvatar: {
    styleOverrides: {
      root: {
        minInlineSize: 'unset',
      },
    },
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        minInlineSize: 0,
        color: 'inherit',
        fontSize: '1.375rem',
        '& > svg, & > i': {
          fontSize: 'inherit',
        },
      },
    },
  },
  MuiListItemButton: {
    styleOverrides: {
      root: ({ theme, ownerState }) => ({
        gap: theme.spacing(2),
        borderRadius: 'var(--mui-shape-customBorderRadius-sm)',
        transition: 'background-color 150ms ease, color 150ms ease',
        ...(!ownerState.dense && {
          paddingBlock: theme.spacing(2),
        }),
        paddingInlineStart: theme.spacing(5),
        '&.Mui-selected': {
          backgroundColor: 'var(--mui-palette-primary-lightOpacity)',
          '&:hover, &.Mui-focused, &.Mui-focusVisible': {
            backgroundColor: 'var(--mui-palette-primary-mainOpacity)',
          },
          '& .MuiTypography-root': {
            color: 'var(--mui-palette-primary-main)',
          },
          '& .MuiListItemIcon-root': {
            color: 'var(--mui-palette-primary-main)',
          },
        },
      }),
    },
  },
  MuiListItemText: {
    styleOverrides: {
      root: {
        margin: 0,
      },
      primary: {
        color: 'inherit',
      },
    },
  },
  MuiListSubheader: {
    styleOverrides: {
      root: ({ theme }) => ({
        ...theme.typography.overline,
        textTransform: 'uppercase' as const,
        letterSpacing: '0.08em',
        color: 'var(--mui-palette-text-disabled)',
        paddingBlock: 10,
        paddingInline: theme.spacing(5),
      }),
    },
  },
};

export default list;
